import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    Route,
} from '@angular/router';
import { RolePermissions } from '../role-permission';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
        private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const token = sessionStorage.getItem("token");
        if (token && token != null && token !== '') {
            return this.checkRolePermission(route, state);
        } else {
            const url = state.url;
            this.router.navigate([`account/login`])
            return false;
        }
    }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    checkRolePermission(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const role = sessionStorage.getItem("role");
        if (!role || !RolePermissions[role]) {
            this.router.navigate(['account/login']);
            return false;
        }

        const routeUrl: string = state.url;

        const hasPermission = RolePermissions[role].some(permission => {
            const formattedPermission = permission.replace(/\./g, "/").toLowerCase();
            return routeUrl.includes(formattedPermission);
        });

        if (!hasPermission) {
            this.router.navigate(['account/login']);
        }

        // Add role as query param if not present
        if (!route.queryParams['role']) {
            const updatedQueryParams = { ...route.queryParams, role };
            this.router.navigate([routeUrl?.split('?')[0]], {
                queryParams: updatedQueryParams,
                queryParamsHandling: '',
                // replaceUrl: true // Prevents adding extra history entries
            });
        }

        return hasPermission;
    }
}
